import { useContext, useState, useCallback, createContext } from 'react';
import { ModalHost } from '../../components/EditModalHost';
import type {
  EditClientModalsContext,
  EditClientModalsState,
  EditClientModalOptions,
  OpenEditModalParams,
} from '../types';
import { getDataForEditModals } from './utils/getDataForEditModals';

const EditClientModalsContext = createContext<EditClientModalsContext | null>(null);

export function EditClientModalsProvider(props: { children: React.ReactNode }) {
  const [state, setState] = useState<EditClientModalsState>({ open: false });
  const [modalOptions, setModalOptions] = useState<EditClientModalOptions>({});

  const openModal = useCallback(
    ({ key, client, documentsData, relatedPassengers, passportData, isLoading }: OpenEditModalParams) => {
      if (isLoading) {
        setState({ open: true, key, status: 'loading' });
        return;
      }

      setState({
        open: true,
        key,
        status: 'ready',
        client: getDataForEditModals(key, client, documentsData, relatedPassengers, passportData),
      });
    },
    []
  );

  const closeModal = useCallback(() => {
    setState({ open: false });
    setModalOptions({});
  }, []);

  return (
    <EditClientModalsContext.Provider value={{ openModal, closeModal, state, modalOptions, setModalOptions }}>
      {props.children}
      <ModalHost state={state} close={closeModal} />
    </EditClientModalsContext.Provider>
  );
}

export function useEditClientModals() {
  const context = useContext(EditClientModalsContext);
  if (!context) {
    throw new Error('useEditClientModals must be used within an EditClientModalsProvider');
  }
  return context;
}
